module.exports = __webpack_public_path__ + "static/media/15-2.b9dbbca4.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wedding_engage/15-2.PNG
// module id = 215
// module chunks = 0